import React from "react";

const SayHello = ({style = {}, size = "36", className = "", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            d="M11.777 21.89c-.274.258-.552-.05-.552-.05s-4.62-4.895-4.92-5.115c-.422-.307-1.327-.79-2.232.143-.378.387-.993 1.25.15 2.64.247.3 7.445 7.885 7.865 8.295 0 0 3.325 3.235 5.337 4.452.558.338 1.185.695 1.918.945.73.25 1.555.423 2.424.423.87.01 1.773-.158 2.625-.47a9.835 9.835 0 0 0 2.37-1.3c.178-.135.358-.27.526-.415l.485-.4c.337-.283.652-.58.954-.883a16.01 16.01 0 0 0 1.638-1.915c.48-.665.888-1.352 1.213-2.037a9.183 9.183 0 0 0 .69-2.023c.145-.647.184-1.26.162-1.795-.005-.535-.112-.992-.2-1.357a5.098 5.098 0 0 0-.292-.818l-.128-.275c-.115-.322-.225-.63-.322-.907-.276-.783-.593-1.66-.923-2.563-.14-.382-.205-.555-.205-.555l.003.008c-1.213-3.293-2.515-6.685-2.515-6.685-.198-.598-.925-.805-1.46-.42-1.546 1.11-2.018 2.73-1.473 4.457l1.398 3.83c.197.428-.348.923-.713.625-1.148-.935-3.575-3.512-3.575-3.512-1.085-1.04-7.207-7.318-7.617-7.7-.825-.768-1.865-1.163-2.658-.58-.81.595-1.035 1.515-.252 2.52.212.272 6.4 6.81 6.4 6.81.36.377-.066.912-.463.545 0 0-7.697-8.03-8.045-8.405-.788-.855-2.053-1.043-2.803-.338-.732.688-.715 1.815.086 2.7.255.28 5.677 6.005 7.847 8.35.145.158.258.368.043.565-.003.003-.22.238-.5-.062-.59-.63-6.483-6.77-6.81-7.103-.753-.765-1.763-1.127-2.575-.382-.74.677-.86 1.86-.01 2.695l7.137 7.545s.232.275-.027.517Z"
            fill="#FAC036"
        />
        <path
            d="m23.365 15.602.602.645s-3.447 3.327-1.097 8.437c0 0 .305.648-.095.755 0 0-.35.195-.75-.8 0-.002-2.373-4.855 1.34-9.037Z"
            fill="#E48C15"
        />
        <path
            d="M17.82 4.55s1.453.22 2.798 1.66c1.345 1.443 1.967 3.295 1.967 3.295M21.36 2.875s1.218.612 2.157 2.125c.94 1.513 1.168 3.262 1.168 3.262M10.928 29.683s-1.465.097-3.088-1.023c-1.622-1.12-2.63-2.795-2.63-2.795M9.882 32.14s-1.36.058-2.92-.805c-1.56-.862-2.61-2.28-2.61-2.28"
            stroke="#fff"
            strokeMiterlimit={10}
            strokeLinecap="round"
        />
    </svg>
);

export default SayHello;

